import React, { Component, Fragment } from "react";
import "./style.css"

import AuthService from "../../Auth/Autenticacao/services/auth.service";
import EventBus from "../../Auth/Autenticacao/common/EventBus";

export default class Header extends Component {

    constructor(props) {
        super(props);
        this.logOut = this.logOut.bind(this);

        this.state = {
            aplicationName: "Header"
        }
    }

    componentDidMount() {
        AuthService.getCurrentUser();

        EventBus.on("logout", () => {
            this.logOut();
        });
    }

    componentWillUnmount() {
        EventBus.remove("logout");
    }

    logOut() {
        AuthService.logout();
        window.location = "/login"
    }

    render() {
        return (
            <Fragment>
                <nav className="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent">
                    <div className="container-fluid">
                        <div className="navbar-wrapper">
                            <div className="navbar-toggle">
                                <button type="button" className="navbar-toggler">
                                    <span className="navbar-toggler-bar bar1"></span>
                                    <span className="navbar-toggler-bar bar2"></span>
                                    <span className="navbar-toggler-bar bar3"></span>
                                </button>
                            </div>
                            <a className="navbar-brand" href="#"></a>
                        </div>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-bar navbar-kebab"></span>
                            <span className="navbar-toggler-bar navbar-kebab"></span>
                            <span className="navbar-toggler-bar navbar-kebab"></span>
                        </button>
                        <div className="collapse navbar-collapse justify-content-end" id="navigation">
                            {/*
                        <form>
                        <div className="input-group no-border">
                            <input type="text" className="form-control" placeholder="Pesquisar..." />
                            <div className="input-group-append">
                            <div className="input-group-text">
                                <i className="nc-icon nc-zoom-split"></i>
                            </div>
                            </div>
                        </div>
                        </form>
                        */}
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <a className="nav-link btn-rotate" href="/profile">
                                        <i className="nc-icon nc-single-02"></i>
                                        <p>
                                            <span className="d-lg-none d-md-block">Configurações</span>
                                        </p>
                                    </a>
                                </li>
                                <li className="nav-item btn-rotate dropdown">
                                    <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="nc-icon nc-settings-gear-65"></i>
                                        <p>
                                            <span className="d-lg-none d-md-block">Opções</span>
                                        </p>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
                                        <a className="dropdown-item" href="/dashboard">Painel</a>
                                        <a className="dropdown-item" href="/unidade">Unidades</a>
                                        <a className="dropdown-item" href="/relatorios">Relatórios</a>
                                        <a className="dropdown-item" onClick={this.logOut} style={{ cursor: "pointer" }} >Sair</a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </Fragment>
        )
    }
}